/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1CourseregistrationSharedClassStudentListQueryResponse,
  GetApiV1CourseregistrationSharedClassStudentListQueryParams,
  GetApiV1CourseregistrationSharedClassStudentList401,
  GetApiV1CourseregistrationSharedClassStudentList500,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedClassStudentList.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1CourseregistrationSharedClassStudentList } from "../../clients/courseRegistrationSharedController/getApiV1CourseregistrationSharedClassStudentList.ts";

export const getApiV1CourseregistrationSharedClassStudentListQueryKey = (
  params?: GetApiV1CourseregistrationSharedClassStudentListQueryParams,
) =>
  [
    { url: "/api/v1/courseregistration/shared/class-student-list" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1CourseregistrationSharedClassStudentListQueryKey =
  ReturnType<typeof getApiV1CourseregistrationSharedClassStudentListQueryKey>;

export function getApiV1CourseregistrationSharedClassStudentListQueryOptions(
  params?: GetApiV1CourseregistrationSharedClassStudentListQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1CourseregistrationSharedClassStudentListQueryKey(params);
  return queryOptions<
    GetApiV1CourseregistrationSharedClassStudentListQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationSharedClassStudentList401
      | GetApiV1CourseregistrationSharedClassStudentList500
    >,
    GetApiV1CourseregistrationSharedClassStudentListQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1CourseregistrationSharedClassStudentList(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna as turmas ativas filtradas por curso, empresa e opcionalmente apenas turmas com monografia. Quando o parâmetro 'mainOnly' é verdadeiro e nenhuma empresa é informada, retorna apenas turmas sem empresa vinculada. A empresa do usuário autenticado sobrepõe o parâmetro 'companyId' quando aplicável. **(Requer Authorization para autenticação)**
 * @summary Retorna a lista de turmas para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/shared/class-student-list}
 */
export function useGetApiV1CourseregistrationSharedClassStudentList<
  TData = GetApiV1CourseregistrationSharedClassStudentListQueryResponse,
  TQueryData = GetApiV1CourseregistrationSharedClassStudentListQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1CourseregistrationSharedClassStudentListQueryKey,
>(
  params?: GetApiV1CourseregistrationSharedClassStudentListQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1CourseregistrationSharedClassStudentListQueryResponse,
        ResponseErrorConfig<
          | GetApiV1CourseregistrationSharedClassStudentList401
          | GetApiV1CourseregistrationSharedClassStudentList500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1CourseregistrationSharedClassStudentListQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1CourseregistrationSharedClassStudentListQueryOptions(
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationSharedClassStudentList401
      | GetApiV1CourseregistrationSharedClassStudentList500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
